import React from "react"
import Carousel from "@components/carousel"
import BundleItem from "./bundle-item"
import { getProductTitleFromVariant } from "./helpers"

const BundleShowcase = ({
  heading,
  description,
  bundle,
  bundleVariants,
  ctaList,
  sliderSettings,
}) => (
  <Carousel
    heading={heading || bundle?.title}
    description={description}
    settings={{ ...sliderSettings, isBundleShowcaseSlider: true }}
    ctaList={ctaList}
    className={"bundle-showcase-slider"}
  >
    {bundleVariants?.map((variant, index) => (
      <BundleItem
        key={index}
        {...variant}
        title={getProductTitleFromVariant(bundle?.bundleProductsList, variant)}
        link={ctaList ? ctaList[0]?.internalLink : null}
      />
    ))}
  </Carousel>
)

export default BundleShowcase
